import React from 'react';
import './MenuItem.scss';
import { IGetMenuItemResponse } from '../../proto/menu/item/menuItem';
import { ensureDataUrl } from '../../utils/imageHandlers';

interface IMenuItemProps {
	item: IGetMenuItemResponse;
	onClick?: () => void;
}

export const MenuItem = ({ item, onClick }: IMenuItemProps): JSX.Element => {
	return (
		<div className="menuItemContainer" onClick={(): void => onClick()}>
			<div className="menuItemImage">
				<img src={ensureDataUrl(item.image)} alt={item.title} />
			</div>
			<div className="menuItemInfo">
				<div className="menuItemName">{item.title}</div>
				<div className="menuItemDescription">{item.description}</div>
			</div>
			<div className="menuItemPrice">₪{item.price}</div>
		</div>
	);
};
